<nav class="navbar fixed-bottom p-0 d-flex align-items-stretch navbar-{{theme.bright}} bg-{{theme.bright}}"
  (contextmenu)="showContextMenu($event)"
  (click)="manageClick()"
  [attr.style]="theme.mainToolbarStyle">

  <div class="left-side d-flex">
    <a class="navbar-brand d-flex align-items-stretch m-0 p-0" title="Start" 
      (contextmenu)="showStartContextMenu($event)"
      (click)="startMenuClick()">
      <div class="text-center flex-fill">
        <i class="fab fa-windows"></i>
      </div>
    </a>
  
    <ng-container *ngFor="let window of allWindows; trackBy: windowsId">
      <app-window-in-bar 
        (contextmenu)="showIconContextMenu($event, window)"
        [window]="window"></app-window-in-bar>
    </ng-container>
  </div>
</nav>

<app-context-menu zIndex="1030" menuId="toolbar-context-menu" direction="up"
  [actions]="toolbarMenuActions" #toolbarMenu></app-context-menu>
<app-context-menu zIndex="1030" menuId="toolbar-icon-context-menu" direction="up"
  [actions]="iconMenuActions" #toolbarIconMenu></app-context-menu>
